import { useEffect } from "react"

import { remove as removePersistValue } from "utils/persist_store"
import { gtmPushDataLayerCountKioskUser } from "utils/googletagmanager"
import { gtmPushSurveyNewSession } from "utils/googletagmanager"

export const useSession = () => {
  const INITIAL_SESSION_KEY = "is_initial_session"
  useEffect(() => {
    removePersistValue("is_initial_session")
  }, [])

  return {
    INITIAL_SESSION_KEY,
    gtmPushSurveyNewSession,
    gtmPushDataLayerCountKioskUser,
  }
}
